import ProviderLogo from "backpack-ui/dist/components/providerLogo";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var BookingProvider = function (_a) {
    var provider = _a.provider, className = _a.className;
    return (React.createElement("div", { className: cn(styles.bookingProvider, className) },
        React.createElement(ProviderLogo, { className: styles.bookingProviderLogo, provider: provider })));
};
export default BookingProvider;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingProvider.tsx
// module id = BK2A
// module chunks = 2